import axios from 'axios';
import { beginSensitiveEgress } from '@/utils/demoEgress';

export async function downloadFrame(frame) {
  const ticket = beginSensitiveEgress('download');
  if (!ticket) return null;
  try {
    const { data } = await axios.get(`api/impact_analytics/frames/${frame.id}/download-url/`);
    if (!ticket.confirm()) return null;
    const a = document.createElement('a');
    a.href = data.url;
    a.download = data.filename || `${String(frame.name || 'frame').replace(/[^a-z0-9]+/gi, '_')}_${frame.id}.csv`;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    return null;
  } catch (err) {
    return err?.response?.status === 403 ? 'Downloading rows needs PHI access.' : 'The download failed.';
  }
}

export async function waitForJob(jobId, ticket = null, { every = 1500, limit = 400 } = {}) {
  let job = { status: 'pending' };
  for (let i = 0; i < limit && (!ticket || ticket.active) && ['pending', 'in_progress'].includes(job.status); i += 1) {
    await new Promise((resolve) => { setTimeout(resolve, every); });
    job = (await axios.get(`api/jobs/${jobId}/status/`)).data;
  }
  return job;
}
